import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api";
import { fmtDateTime } from "../../lib/format";
import {
  SectionHeading,
  StatusBadge,
  Loading,
  EmptyState,
} from "../../components/ui";

interface Row {
  id: string;
  memberId: string;
  memberNo: string;
  displayName: string;
  isCompleted: number;
  completedAt: string | null;
}

export function AdminHearingsPage() {
  const [items, setItems] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<{ items: Row[] }>("/admin/hearings")
      .then((r) => setItems(r.items))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <SectionHeading
        level={2}
        action={
          <a
            href="/api/admin/hearings/export.csv"
            className="btn-outline text-sm"
            download
          >
            CSV ダウンロード
          </a>
        }
      >
        ヒアリング管理
      </SectionHeading>
      {loading ? (
        <Loading />
      ) : items.length === 0 ? (
        <EmptyState title="まだヒアリング回答はありません" />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm border border-black/10">
            <thead className="bg-black/5 text-left">
              <tr>
                <th className="p-2">会員番号</th>
                <th className="p-2">表示名</th>
                <th className="p-2">完了</th>
                <th className="p-2">完了日時</th>
                <th className="p-2">操作</th>
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} className="border-t border-black/10">
                  <td className="p-2 font-mono text-xs">{r.memberNo}</td>
                  <td className="p-2">{r.displayName}</td>
                  <td className="p-2">
                    {r.isCompleted === 1 ? (
                      <StatusBadge tone="success" bold>
                        完了
                      </StatusBadge>
                    ) : (
                      <StatusBadge tone="warning">未完了</StatusBadge>
                    )}
                  </td>
                  <td className="p-2">{fmtDateTime(r.completedAt)}</td>
                  <td className="p-2">
                    <Link
                      to={`/admin/members/${r.memberId}`}
                      className="text-tora underline text-xs"
                    >
                      会員詳細へ
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
